import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'advanced',
  templateUrl: './advanced.component.html',
  styleUrls: ['./advanced.component.scss']
})
export class AdvancedComponent implements OnInit {

  advancedItems;

  constructor() {
    this.advancedItems = [
      {routerLink: 'calls', name: 'Calls'},
      {routerLink: 'users', name: 'Users'},
      {routerLink: 'statistics', name: 'Statistics'}
    ];
  }

  ngOnInit(): void {
  }

}
